import apiClient from './apiClient'

export interface SubscriptionPlan {
  id: number
  plan_type: 'basic' | 'professional' | 'enterprise'
  name: string
  description?: string
  max_bots: number
  max_attendants: number
  features?: any
  price?: number
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface CreatePlanRequest {
  plan_type: 'basic' | 'professional' | 'enterprise'
  name: string
  description?: string
  max_bots: number
  max_attendants: number
  features?: any
  price?: number
  is_active?: boolean
}

export interface UpdatePlanRequest {
  name?: string
  description?: string
  max_bots?: number
  max_attendants?: number
  features?: any
  price?: number
  is_active?: boolean
}

export interface PlanListResponse {
  plans: SubscriptionPlan[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
}

export const subscriptionPlanService = {
  // Listar planos
  async getPlans(page = 1, limit = 10): Promise<PlanListResponse> {
    const response = await apiClient.get(`/subscription-plans?page=${page}&limit=${limit}`)
    return response.data.data
  },

  // Obter planos ativos
  async getActivePlans(): Promise<SubscriptionPlan[]> {
    const response = await apiClient.get('/subscription-plans/active')
    return response.data.data
  },

  // Obter plano por ID
  async getPlan(id: number): Promise<SubscriptionPlan> {
    const response = await apiClient.get(`/subscription-plans/${id}`)
    return response.data.data
  },

  // Criar plano
  async createPlan(planData: CreatePlanRequest): Promise<SubscriptionPlan> {
    const response = await apiClient.post('/subscription-plans', planData)
    return response.data.data
  },

  // Atualizar plano
  async updatePlan(id: number, planData: UpdatePlanRequest): Promise<SubscriptionPlan> {
    const response = await apiClient.put(`/subscription-plans/${id}`, planData)
    return response.data.data
  },

  // Deletar plano
  async deletePlan(id: number): Promise<void> {
    await apiClient.delete(`/subscription-plans/${id}`)
  },

  // Aplicar template de plano
  async applyPlanTemplate(planType: string, adminId: number): Promise<any> {
    const response = await apiClient.post(`/subscription-plans/${planType}/apply`, { adminId })
    return response.data.data
  }
}








